// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SnIs40ISaSqTqZ {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: var(--ds-space-050, 4px);
  margin: var(--ds-space-0, 0) var(--ds-space-negative-050, -4px);
  margin-top: var(--ds-space-100, 8px);
  margin-bottom: var(--ds-space-200, 16px);
}
.hPWASVbIXYzcTo {
  margin-right: var(--ds-space-0, 0);
  margin-left: var(--ds-space-0, 0);
}
.MrV_VNP6MnvXux {
  display: contents;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"palette": `SnIs40ISaSqTqZ`,
	"noHorizontalMargin": `hPWASVbIXYzcTo`,
	"focusLock": `MrV_VNP6MnvXux`
};
export default ___CSS_LOADER_EXPORT___;
